import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = ((baseURL) => {
  return {
    getSenderStatus: `${baseURL}/api/sender/status`,
    registedSender: `${baseURL}/api/sender/register`,
    getVerifiedSenders: (params) =>
      `${baseURL}/api/senders/search?${encodeParams(params)}`,
    getUncompleted: (idMessage) =>
      `${baseURL}/api/message/${idMessage}/uncompleted`,
    checkSendingProgress: (idMessage) =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}/running`
  }
})(process.env.BESENDGO_URL)

/**
 * @typedef {Object} TrustedSenderStatusResponse
 * @property {('NotConfirmed'|'Confirmed'|'Blocked'|'DeliverOk'|'DeliverWarn'|'DeliverError'|'NoDeliver'|'DeliverIsp')} Status
 * @property {string} AuthDate datetime string
 *
 * @description Get a registered sender status. Mind that Trusted senders are bounded only to IdList = 0
 * @param {string} EmailAddress
 * @param {('CON'|'O2M')} ServiceType
 * @returns {TrustedSenderStatusResponse} Trusted sender status response
 */
export const beSendGetSenderStatus = (
  EmailAddress,
  ServiceType = 'CON',
  cancelToken = undefined
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getSenderStatus,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({
      EmailAddress,
      ServiceType
    }),
    cancelToken
  }).then(({ data }) => data)
}

/**
 * @typedef {Object} TrustedSenderRegisterResponse
 * @property {boolean} Value
 *
 * @description Register a new sender for authorization. This will insert a new sender and send an email for confirmation. While not confirmed this method can be used to resend the confirmation email.
 * @param {string} EmailAddress
 * @param {('CON'|'O2M')} ServiceType
 * @param {number} IdList default 0
 * @returns {TrustedSenderRegisterResponse} Trusted sender status response
 */
export const beSendRegisterSender = (
  EmailAddress,
  ServiceType = 'CON',
  IdList = 0,
  cancelToken
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.registedSender,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({
      EmailAddress,
      ServiceType,
      IdList
    }),
    cancelToken
  }).then(({ data }) => data)
}

export const beSendGetVerifiedSenders = (params, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getVerifiedSenders(params),
    data: JSON.stringify(data)
  }).then((res) => res.data)
}

export const beSendGetUncompleted = (idMessage) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getUncompleted(idMessage)
  }).then((res) => res.data)
}

export const beSendGoCheckSendingProgress = (idMessage) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.checkSendingProgress(idMessage)
  }).then((res) => res.data)
}

export const TRUSTED_SENDER_STATUS_NOT_CONFIRMED = 'NotConfirmed'
export const TRUSTED_SENDER_STATUS_CONFIRMED = 'Confirmed'
export const TRUSTED_SENDER_STATUS_BLOCKED = 'Blocked'
export const TRUSTED_SENDER_STATUS_DELIVER_OK = 'DeliverOk'
export const TRUSTED_SENDER_STATUS_DELIVER_WARN = 'DeliverWarn'
export const TRUSTED_SENDER_STATUS_DELIVER_ERROR = 'DeliverError'
export const TRUSTED_SENDER_STATUS_DELIVER_ISP = 'DeliverIsp'
export const TRUSTED_SENDER_STATUS_NO_DELIVER = 'NoDeliver'
